import * as React from 'react';
import { render } from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import { trackProductDetailsView } from '../../analytics';
import ViewerApp from './viewer/viewerApp';
import ReserveCollectApp from './reserveCollect/reserveCollectApp';
import BuyGiftCardApp from './buyGiftCard/buyGiftCardApp';
import ProductStylesModal from './productStylesModal/modal';
import SizeGuideModal from './sizeGuideModal/sizeGuideModal';
import FinanceModalApp from './financeModal/financeModalApp';
import ProductSpecificationsModalApp from './productSpecificationsModal/productSpecifications';
import DeliveryInformationModal from './deliveryInformationModal/deliveryInformationModal';
import GiftCardTermsAndConditionsModal from './giftcardTermsAndConditionsModal/giftcardTermsAndConditionsModal';
import { MessagePropertiesProvider } from '../../contexts/messageProperties';
import { addToCartFormHandler, addToCartDisabledButtonHandler } from '../../helpers/addToCartHandler';
import { favouritesButtonHandler } from '../../helpers/favouritesHandler';
import listbox from '../../cmsComponents/listbox';
import initStickyAddToBag from './pdpComponents/stickyAddToBag';
import initReadMoreButton from './pdpComponents/productDescription';

import '../../../../pcss/pdp_app.pcss';

smoothscroll.polyfill();

trackProductDetailsView();

window.addEventListener('DOMContentLoaded', () => {
  const viewerRoot = document.getElementById('viewerRoot');
  if (viewerRoot) {
    render(
      <MessagePropertiesProvider>
        <ViewerApp />
      </MessagePropertiesProvider>,
      viewerRoot
    );
  }

  const buyGiftCardRoot = document.getElementById('buyGiftCardRoot');
  if (buyGiftCardRoot) {
    render(
      <MessagePropertiesProvider>
        <BuyGiftCardApp />
      </MessagePropertiesProvider>,
      buyGiftCardRoot
    );
  }

  const productOptionsModal = document.getElementById('productOptionsModalRoot');
  if (productOptionsModal) {
    render(
      <MessagePropertiesProvider>
        <ProductStylesModal />
      </MessagePropertiesProvider>,
      productOptionsModal
    );
  }

  const sizeGuideModalRoot = document.getElementById('sizeGuideModalRoot');
  if (sizeGuideModalRoot) {
    render(
      <MessagePropertiesProvider>
        <SizeGuideModal />
      </MessagePropertiesProvider>,
      sizeGuideModalRoot
    );
  }

  const reserveCollectParentElement = document.getElementById('reserveCollect');
  if (reserveCollectParentElement) {
    render(
      <MessagePropertiesProvider>
        <ReserveCollectApp />
      </MessagePropertiesProvider>,
      reserveCollectParentElement
    );
  }

  const productSpecificationsModalRoot = document.getElementById('productSpecificationsModalRoot');
  if (productSpecificationsModalRoot) {
    render(
      <MessagePropertiesProvider>
        <ProductSpecificationsModalApp />
      </MessagePropertiesProvider>,
      productSpecificationsModalRoot
    );
  }

  const financeModalRoot = document.getElementById('financeModalRoot');
  if (financeModalRoot) {
    render(
      <MessagePropertiesProvider>
        <FinanceModalApp />
      </MessagePropertiesProvider>,
      financeModalRoot
    );
  }

  const deliveryInformationModalRoot = document.getElementById('deliveryInformationModalRoot');
  if (deliveryInformationModalRoot) {
    render(
      <MessagePropertiesProvider>
        <DeliveryInformationModal />
      </MessagePropertiesProvider>,
      deliveryInformationModalRoot
    );
  }

  const giftcardTermsAndConditionsModalRoot = document.getElementById('giftcardTermsAndConditionsModalRoot');
  if (giftcardTermsAndConditionsModalRoot) {
    render(
      <MessagePropertiesProvider>
        <GiftCardTermsAndConditionsModal />
      </MessagePropertiesProvider>,
      giftcardTermsAndConditionsModalRoot
    );
  }

  const listboxElement = document.querySelector('.listbox');
  const { initListbox } = listbox(listboxElement);
  initListbox();

  initStickyAddToBag();
  initReadMoreButton();
  addToCartFormHandler();
  addToCartDisabledButtonHandler();
  favouritesButtonHandler();
});
